import React from 'react'
import { Select } from 'components/forms/Selects'
import PropTypes from 'prop-types'
import { PhoneInput } from 'transfix-ui/components/PhoneInput'
import { TextInput } from 'components/atoms'
import { userTypes, roles } from 'constants/userTypes'

const USER_TYPES = userTypes.carrier
  .filter(type => type.value !== 'driver')
  .map(({ name, value }) => ({ label: name, value }))
const ROLES = roles.map(({ name, value }) => ({ label: name, value }))

export const AddNewUser = React.memo(
  ({ cellPhone, email, firstName, handleUserChange, lastName, phone, role, userType }) => {
    const selectHandler = ({ value }, id) => {
      handleUserChange({ target: { value, id } })
    }
    return (
      <div className='row'>
        <div className='col-xs-6'>
          <Select
            id='userType'
            dataTest='user-type'
            placeholder='Select a type'
            label='User Type'
            options={USER_TYPES}
            value={USER_TYPES.find(entry => entry.value === userType)}
            onChange={selectHandler}
            required
          />
        </div>
        <div className='col-xs-6'>
          <Select
            id='role'
            dataTest='role'
            placeholder='Select a Role'
            label='Role'
            options={ROLES}
            value={ROLES.find(entry => entry.value === role)}
            onChange={selectHandler}
            required
          />
        </div>
        <div className='col-xs-6'>
          <TextInput
            label='First Name'
            required
            id='firstName'
            value={firstName || ''}
            onChange={handleUserChange}
            dataTest='first-name'
            placeholder='Jane'
          />
        </div>
        <div className='col-xs-6'>
          <TextInput
            label='Last Name'
            required
            id='lastName'
            value={lastName}
            onChange={handleUserChange}
            dataTest='last-name'
            placeholder='Doe'
          />
        </div>
        <div className='col-xs-6'>
          <TextInput
            label='Email'
            required
            id='email'
            value={email || ''}
            onChange={handleUserChange}
            dataTest='email'
            placeholder='carrier@carrier.com'
          />
        </div>
        <div className='col-xs-6'>
          <PhoneInput
            id='phone'
            label='Phone'
            placeholder='(000)-000-0000'
            value={phone || ''}
            onChange={handleUserChange}
            dataTest='phone'
            required
          />
        </div>
        {userType === 'owner_operator' && (
          <div className='col-xs-6'>
            <PhoneInput
              id='cellPhone'
              label='Cell Phone'
              placeholder='(000)-000-0000'
              value={cellPhone || ''}
              onChange={handleUserChange}
              dataTest='cell-phone'
              required
            />
          </div>
        )}
      </div>
    )
  }
)

AddNewUser.propTypes = {
  userType: PropTypes.string.isRequired,
  role: PropTypes.string.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  cellPhone: PropTypes.string.isRequired,
  handleUserChange: PropTypes.func.isRequired,
}
